var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
    customClass: _vm.tooltipClass,
    placement: _vm.placement,
    boundary: _vm.boundary,
    trigger: 'hover',
  }),expression:"{\n    customClass: tooltipClass,\n    placement: placement,\n    boundary: boundary,\n    trigger: 'hover',\n  }"}],attrs:{"title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }